import { render, staticRenderFns } from "./TheSourcePage.vue?vue&type=template&id=7c59038a&scoped=true&"
import script from "./TheSourcePage.vue?vue&type=script&lang=js&"
export * from "./TheSourcePage.vue?vue&type=script&lang=js&"
import style0 from "./TheSourcePage.vue?vue&type=style&index=0&id=7c59038a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c59038a",
  null
  
)

export default component.exports